import React from "react";
import Faq from "react-faq-component";
import Text from "../../common/Text";
import "../../../../src/CSS/App.css";
import styles from "../../../../src/CSS/sections/Accordion.module.css";

const Faqs = ({ content, faqs }) => {
  return (
    <>
      {content && (
        <section className={`${styles.faqNew} padding-y`}>
          <div className="container">
            <div className="text-center">
              <h2 className="heading1" style={{marginBottom: 56}}>
                {/* <Text string={content.faq_heading} /> */}
                {content.faq_heading}
              </h2>
            </div>
            <div className="accordion" id="faqAccordion">
            {faqs.rows.map((item, index) => (
              <div className={`accordion-item ${styles.item}`} key={index}>
                <h4 className="accordion-header">
                  <button
                    className={`accordion-button collapsed ${styles.button}`}
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target={`#collapse-${index}`}
                    aria-expanded="false"
                  >
                    <span className="me-auto">{item.title}</span>

                    {/* Single SVG for both states */}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="23"
                      height="23"
                      viewBox="0 0 23 23"
                      fill="none"
                      className={styles.icon}
                    >
                      <g clip-path="url(#clip0_797_8463)">
                        <path
                          d="M0.552458 11.8663C0.443163 11.7571 0.368724 11.6178 0.338559 11.4663C0.308394 11.3147 0.323858 11.1576 0.382993 11.0148C0.442128 10.8721 0.542279 10.75 0.670776 10.6642C0.799274 10.5783 0.950347 10.5325 1.10488 10.5325L21.5226 10.5325C21.7298 10.5325 21.9286 10.6149 22.0751 10.7614C22.2216 10.9079 22.3039 11.1067 22.3039 11.3139C22.3039 11.5211 22.2216 11.7199 22.0751 11.8664C21.9286 12.0129 21.7298 12.0952 21.5226 12.0952L1.10488 12.0952C1.00226 12.0953 0.900635 12.0752 0.805832 12.0359C0.71103 11.9966 0.624922 11.939 0.552458 11.8663Z"
                          fill="#9C9C9C"
                        />
                        <path
                          d="M10.7613 22.0751C10.6886 22.0027 10.631 21.9166 10.5917 21.8218C10.5524 21.727 10.5322 21.6253 10.5324 21.5227L10.5324 1.105C10.5324 0.897772 10.6147 0.699032 10.7612 0.5525C10.9077 0.405968 11.1065 0.323647 11.3137 0.323647C11.5209 0.323647 11.7197 0.405968 11.8662 0.5525C12.0127 0.699032 12.0951 0.897772 12.0951 1.105L12.0951 21.5227C12.0951 21.6772 12.0493 21.8283 11.9634 21.9568C11.8776 22.0853 11.7555 22.1855 11.6128 22.2446C11.47 22.3037 11.3129 22.3192 11.1613 22.289C11.0097 22.2589 10.8705 22.1844 10.7613 22.0751Z"
                          fill="#9C9C9C"
                        />
                      </g>
                      <defs>
                        <clipPath id="clip0_797_8463">
                          <rect
                            width="16"
                            height="16"
                            fill="white"
                            transform="translate(11.3137) rotate(45)"
                          />
                        </clipPath>
                      </defs>
                    </svg>
                  </button>
                </h4>

                <div
                  id={`collapse-${index}`}
                  className="accordion-collapse collapse"
                  data-bs-parent="#faqAccordion"
                >
                  <div className={`accordion-body ${styles.body}`}>
                    {item.content}
                  </div>
                </div>
              </div>
            ))}
            </div>
            {/* <Faq data={faqs} /> */}
          </div>
        </section>
      )}
    </>
  );
};

export default Faqs;